import { createReducer } from 'typesafe-actions'
import { combineReducers } from 'redux'
import { RequestStatus } from '../../responses/response'
import { createPaginatedAction } from '../../utils/redux-utils'
import { ClientWithBrands } from '../../responses/refs/refs'
import { ID } from '../../types/UtilityTypes'
import { projectActions } from '../data/project/project-actions'
import { taskActions } from '../data/task/task-actions'
import { UserWithDepartments } from '../../responses/users'

const actions = {
    clients: createPaginatedAction(
        '@PROJECT_EDIT/CLIENTS_INIT',
        '@PROJECT_EDIT/CLIENTS_MORE',
        '@PROJECT_EDIT/CLIENTS_SUCCESS',
        '@PROJECT_EDIT/CLIENTS_FAILURE',
    )<undefined, ClientWithBrands[]>(),
    users: createPaginatedAction(
        '@PROJECT_EDIT/USERS_INIT',
        '@PROJECT_EDIT/USERS_MORE',
        '@PROJECT_EDIT/USERS_SUCCESS',
        '@PROJECT_EDIT/USERS_FAILURE',
    )<string, UserWithDepartments[]>(),
}

export { actions as projectEditActions }

export interface ProjectEditState {
    project: ID,
    getStatus: RequestStatus,
    updateStatus: RequestStatus,
}

export const projectEditReducer = combineReducers<ProjectEditState>({
    project: createReducer<ID>(0).handleAction(projectActions.get.success, (_, action) => action.payload.id),
    getStatus: createReducer(RequestStatus.INITIAL)
        .handleAction(projectActions.get.request, () => RequestStatus.FETCHING)
        .handleAction(projectActions.get.success, () => RequestStatus.SUCCESS)
        .handleAction(projectActions.get.failure, () => RequestStatus.FAILURE),
    updateStatus: createReducer<RequestStatus>(RequestStatus.INITIAL)
        .handleAction([
            taskActions.update.request,
            taskActions.create.request,
        ], () => RequestStatus.FETCHING)
        .handleAction([
            taskActions.update.success,
            taskActions.create.success,
        ], () => RequestStatus.SUCCESS)
        .handleAction([
            taskActions.update.failure,
            taskActions.create.failure,
        ], () => RequestStatus.FAILURE),
})

